// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf } from 'lodash';
import routes from '../../routing/analytics/routes';
import Button from '../common/Button';
// css
import '../../styles/components/analytics/AnalyticsControls.scss';


class AnalyticsControls extends Component {

  getVisibleRoutes() {
    return routes.filter(route => route.isHidden ? !route.isHidden(this.props) : true);
  }

  getRoute(index) {
    return this.getVisibleRoutes()[index];
  }

  getCurrentPageIndex() {
    return indexOf(this.getVisibleRoutes().map(route => route.name), this.props.currentPage);
  }

  getCurrentPageRoute() {
    return this.getRoute(this.getCurrentPageIndex());
  }

  hasAreaSubNavigation() {
    return this.getCurrentPageRoute().name.includes('/:areaId');
  }

  getIndexOfCurrentAreaSubNavigation() {
    return this.props.navigableAreas.findIndex(area => area.id === parseInt(this.props.currentAreaId));
  }

  hasPreviousAreaSubNavigation() {
    return this.hasAreaSubNavigation() && this.getIndexOfCurrentAreaSubNavigation() > 0;
  }

  hasNextAreaSubNavigation() {
    return this.hasAreaSubNavigation() && this.getIndexOfCurrentAreaSubNavigation() < this.props.navigableAreas.length - 1;
  }

  getPreviousAreaSubNavigationId() {
    return this.props.navigableAreas[this.getIndexOfCurrentAreaSubNavigation() - 1].id;
  }

  getNextAreaSubNavigationId() {
    return this.props.navigableAreas[this.getIndexOfCurrentAreaSubNavigation() + 1].id;
  }

  getFirstNavigableAreaId() {
    return this.props.navigableAreas[0].id;
  }

  getLastNavigableAreaId() {
    return this.props.navigableAreas[this.props.navigableAreas.length - 1].id;
  }

  getPreviousAreaSubNavigationRoute() {
    return [
      this.getBasePath(),
      this.getRoute(this.getCurrentPageIndex()).name.replace(':areaId', this.getPreviousAreaSubNavigationId())
    ].join('/');
  }

  getNextAreaSubNavigationRoute() {
    return [
      this.getBasePath(),
      this.getRoute(this.getCurrentPageIndex()).name.replace(':areaId', this.getNextAreaSubNavigationId())
    ].join('/');
  }

  hasDashboardCategorySubNavigation() {
    return this.getCurrentPageRoute().name.includes('/:dashboardCategoryId');
  }

  getIndexOfCurrentDashboardCategorySubNavigation() {
    return this.props.navigableDashboardCategories.findIndex(category => category.id === parseInt(this.props.currentDashboardCategoryId));
  }

  hasPreviousDashboardCategorySubNavigation() {
    return this.hasDashboardCategorySubNavigation() && this.getIndexOfCurrentDashboardCategorySubNavigation() > 0;
  }

  hasNextDashboardCategorySubNavigation() {
    return this.hasDashboardCategorySubNavigation() && this.getIndexOfCurrentDashboardCategorySubNavigation() < this.props.navigableDashboardCategories.length - 1;
  }

  getPreviousDashboardCategorySubNavigationId() {
    return this.props.navigableDashboardCategories[this.getIndexOfCurrentDashboardCategorySubNavigation() - 1].id;
  }

  getNextDashboardCategorySubNavigationId() {
    return this.props.navigableDashboardCategories[this.getIndexOfCurrentDashboardCategorySubNavigation() + 1].id;
  }

  getFirstNavigableDashboardCategoryId() {
    return this.props.navigableDashboardCategories[0].id;
  }

  getLastNavigableDashboardCategoryId() {
    return this.props.navigableDashboardCategories[this.props.navigableDashboardCategories.length - 1].id;
  }

  getPreviousDashboardCategorySubNavigationRoute() {
    return [
      this.getBasePath(),
      this.getRoute(this.getCurrentPageIndex()).name.replace(':dashboardCategoryId', this.getPreviousDashboardCategorySubNavigationId())
    ].join('/');
  }
  getNextDashboardCategorySubNavigationRoute() {
    return [
      this.getBasePath(),
      this.getRoute(this.getCurrentPageIndex()).name.replace(':dashboardCategoryId', this.getNextDashboardCategorySubNavigationId())
    ].join('/');
  }

  hasPreviousPage() {
    return (
      this.hasPreviousAreaSubNavigation() ||
      this.hasPreviousDashboardCategorySubNavigation() ||
      this.getCurrentPageIndex() > 0
    );
  }

  hasNextPage() {
    return (
      this.hasNextAreaSubNavigation() ||
      this.hasNextDashboardCategorySubNavigation() ||
      this.getCurrentPageIndex() < this.getVisibleRoutes().length - 1
    );
  }

  getBasePath() {
    let parts = this.props.location.pathname.split('/');
    parts.pop();

    if (this.hasAreaSubNavigation() || this.hasDashboardCategorySubNavigation()) {
      parts.pop();
    }
    return parts.join('/');
  }

  getNextPageRoute() {
    if (this.hasNextAreaSubNavigation()) {
      return this.getNextAreaSubNavigationRoute();
    } else if (this.hasNextDashboardCategorySubNavigation()) {
      return this.getNextDashboardCategorySubNavigationRoute();
    }

    return [
      this.getBasePath(),
      this.getRoute(this.getCurrentPageIndex() + 1).name
        .replace(':areaId', this.getFirstNavigableAreaId())
        .replace(':dashboardCategoryId', this.getFirstNavigableDashboardCategoryId())
    ].join('/');
  }

  getPreviousPageRoute() {
    if (this.hasPreviousAreaSubNavigation()) {
      return this.getPreviousAreaSubNavigationRoute();
    } else if (this.hasPreviousDashboardCategorySubNavigation()) {
      return this.getPreviousDashboardCategorySubNavigationRoute();
    }

    return [
      this.getBasePath(),
      this.getRoute(this.getCurrentPageIndex() - 1).name
        .replace(':areaId', this.getLastNavigableAreaId())
        .replace(':dashboardCategoryId', this.getLastNavigableDashboardCategoryId())
    ].join('/');
  }

  renderPreviousButton() {
    if (this.hasPreviousPage()) {
      return (
        <div className='analytics-controls__previous-button-container'>
          <Button
            to={this.getPreviousPageRoute()}
            label='Previous'
          />
        </div>
      );
    }
  }

  renderNextButton() {
    if (this.hasNextPage()) {
      return (
        <div className='analytics-controls__next-button-container'>
          <Button
            to={this.getNextPageRoute()}
            label='Next'
            primary
          />
        </div>
      );
    }
  }

  render() {
    return (
      <div className='analytics-controls'>
        <div className='container'>
          {this.renderPreviousButton()}
          {this.renderNextButton()}
        </div>
      </div>
    );
  }
}

AnalyticsControls.propTypes = {
  currentAreaId: PropTypes.string,
  currentDashboardCategoryId: PropTypes.string,
  navigableAreas: PropTypes.array.isRequired,
  navigableDashboardCategories: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  currentPage: PropTypes.string.isRequired
};

export default AnalyticsControls;



// WEBPACK FOOTER //
// ./src/components/analytics/AnalyticsControls.js